module.exports = __webpack_public_path__ + "img/gift4-02-c1.97f12c08.png";